import React from "react";

const Navbar = () => (
	<nav className="bg-white shadow-md sticky top-0 z-50">
		<div className="max-w-6xl mx-auto px-4 py-4 flex justify-between items-center">
			<div className="flex items-center space-x-4">
				{/* <img src="./assets/trivnet.png" alt="" className="w-[120px]" /> */}
				<a href="/" className="text-4xl font-bold text-red-600">
					INOVATIVA
				</a>
			</div>

			<div className="space-x-6">
				<a
					href="#about"
					className="text-red-950 font-semibold hover:text-red-800"
				>
					About
				</a>
				<a
					href="#services"
					className="text-red-950 font-semibold hover:text-red-800"
				>
					Services
				</a>
				<a
					href="#contact"
					className="text-red-950 font-semibold hover:text-red-800"
				>
					Contact
				</a>
			</div>
		</div>
	</nav>
);

export default Navbar;
